/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * How one rule of a configured action evaluated, or why it was not consulted.
 * @export
 * @interface DryRunRule
 */
export interface DryRunRule {
    /**
     * 
     * @type {string}
     * @memberof DryRunRule
     */
    rule: string;
    /**
     * 
     * @type {number}
     * @memberof DryRunRule
     */
    position: number;
    /**
     * 
     * @type {boolean}
     * @memberof DryRunRule
     */
    hasCondition: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DryRunRule
     */
    matches: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DryRunRule
     */
    error: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DryRunRule
     */
    reached: boolean;
}

/**
 * Check if a given object implements the DryRunRule interface.
 */
export function instanceOfDryRunRule(value: object): value is DryRunRule {
    if (!('rule' in value) || value['rule'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if ((!('hasCondition' in (value as Record<string, any>)) && !('has_condition' in (value as Record<string, any>))) || ((value as Record<string, any>)['hasCondition'] === undefined && (value as Record<string, any>)['has_condition'] === undefined)) return false;
    if (!('matches' in value) || value['matches'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    if (!('reached' in value) || value['reached'] === undefined) return false;
    return true;
}

export function DryRunRuleFromJSON(json: any): DryRunRule {
    return DryRunRuleFromJSONTyped(json, false);
}

export function DryRunRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): DryRunRule {
    if (json == null) {
        return json;
    }
    return {
        
        'rule': json['rule'],
        'position': json['position'],
        'hasCondition': json['has_condition'],
        'matches': json['matches'],
        'error': json['error'],
        'reached': json['reached'],
    };
}

export function DryRunRuleToJSON(json: any): DryRunRule {
    return DryRunRuleToJSONTyped(json, false);
}

export function DryRunRuleToJSONTyped(value?: DryRunRule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rule': value['rule'],
        'position': value['position'],
        'has_condition': value['hasCondition'],
        'matches': value['matches'],
        'error': value['error'],
        'reached': value['reached'],
    };
}

